import { render, staticRenderFns } from "./ScientificNames.vue?vue&type=template&id=56d2d0d7"
import script from "./ScientificNames.vue?vue&type=script&lang=js"
export * from "./ScientificNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports